import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AppConstants } from "../../app.constants";
import { Observable, of } from "rxjs";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";


@Injectable({
  providedIn: 'root'
})
export class SubscriberMailUsersService {

  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  getSubscriberMailUsers(email): Observable<any> {
    const params = new HttpParams()
      .set('user_email', email.toString())
    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.SUBSCRIBER_EMAIL_USERS.SUBSCRIBER_MAIL_USER}`, { params }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  DeleteSubscriberMailUser(data): Observable<any> {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: data // Pass the body in the options
    };
    return this.http.delete(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.SUBSCRIBER_EMAIL_USERS.SUBSCRIBER_MAIL_USER}`, options
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
